export default __webpack_public_path__ + "static/media/world-wide-web.10a2be69.png";